import { render, staticRenderFns } from "./customSwitch.vue?vue&type=template&id=dcbc35c2&scoped=true"
import script from "./customSwitch.vue?vue&type=script&lang=js"
export * from "./customSwitch.vue?vue&type=script&lang=js"
import style0 from "./customSwitch.vue?vue&type=style&index=0&id=dcbc35c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbc35c2",
  null
  
)

export default component.exports